import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.testimonial-slider-double' ).length ) {
        $( '.testimonial-slider-double' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perPage: 2,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              768: {
                perPage: 1,
              },
            },
          } );

          const splideNav = splide.root.querySelector( '.testimonial-slider-double__splide-nav' );
          const progressBar = splide.root.querySelector( '.service-slider__progress-bar' );
          const progressAmount = splide.root.querySelector( '.service-slider__progress-amount' );

          splide.on( 'overflow', function( isOverflow ) {
            splide.options = {
              arrows: isOverflow,
              drag: isOverflow,
              clones: isOverflow ? undefined : 0,
            };
            if ( splideNav ) {
              splideNav.style.display = isOverflow ? 'flex' : 'none';
            }
          } );

          if ( progressBar ) {
            splide.on( 'mounted refresh move', function() {
              const end = splide.Components.Controller.getEnd() + 1;
              const slideCount = splide.Components.Slides.getLength();
              const rate = Math.min( ( splide.index + 1 ) / end, 1 );
              progressBar.style.width = String( 100 * rate ) + '%';

              if ( slideCount >= 3 ) {
                $( progressAmount ).text( `${splide.index + 3} of ${slideCount} reviews` );
              } else {
                $( progressAmount ).text( `${slideCount} of ${slideCount} reviews` );
              }
            } );
          }

          let rafId;
          const refresh = () => {
            if ( rafId ) cancelAnimationFrame( rafId );
            rafId = requestAnimationFrame( () => splide.refresh() );
          };

          splide.on( 'resize', refresh );
          splide.on( 'updated', refresh );

          [window.matchMedia( '(max-width: 1024px)' ),
            window.matchMedia( '(max-width: 768px)' )].forEach( ( mq ) => {
            mq.addEventListener( 'change', refresh );
          } );

          splide.mount( {} );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'testimonial-slider-double', COMPONENT );
} )( app );
